import React from 'react';

import { Select, SelectProps } from '@chakra-ui/react';
import { GlobalError, InternalFieldName, UseFormRegisterReturn } from 'react-hook-form';

import { FormControl } from '../FormControl/FormControl';

type FormSelectProps<TFieldName extends InternalFieldName = InternalFieldName> = {
	label: string;
	type?: string;
	error: GlobalError | undefined;
	helperText?: string;
	defaultValue?: string;
	placeholder?: string;
	children: SelectProps['children'];
	className?: string;
} & Omit<UseFormRegisterReturn<TFieldName>, 'ref'>;

export const FormSelect = React.forwardRef<HTMLSelectElement, FormSelectProps>((props, ref) => {
	const { type, ...formControlProps } = props;
	const { helperText, required, className, ...selectProps } = props;
	return (
		<FormControl {...formControlProps}>
			<Select
				ref={ref}
				id={props.name}
				bg="white"
				display={'flex'}
				color="secondary.700"
				alignItems={'center'}
				className="py-0"
				{...selectProps}
			>
				{props.children}
			</Select>
		</FormControl>
	);
});
